
import Logo from "../../assets/Logo.svg"

const Header = () => (
    <div className="py-10 px-20 font-playfair sticky top-0 bg-white z-10">
        <img alt='logo' className="w-40" src={Logo} />
    </div>
)

export default Header